
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { QueryChart } from "../../../../component/solution/QueryChart/QueryChart";
import { useAuth } from "../../../../contexts/AuthContext";
import { CastType, IQuery } from "../../../../component/solution/Interfaces";


export const DashIS: React.FC = () => {

  const {fetchData}  = useAuth();
  const [shipmentsState, setShipmentsState] = useState<number>(0);
  const [movementsInState, setMovementsInState] = useState<number>(0);
  const [movementsOutState, setMovementsOutState] = useState<number>(0);
  const [stockmasterState, setStockmasterState] = useState<number>(0);
  const [adjustmentsState, setAdjustmentsState] = useState<number>(0);
  const [levelsState, setLevelsState] = useState<number>(0); 

  const queryUrl: string = `${process.env.REACT_APP_BASE_URL}/${"query/data"}`;

  // useEffect(() => {

  //   // // Shipments
  //   // fetchData(queryUrl, {method:"POST", body: JSON.stringify(shipmentsQuery)}, (result: any) => {
  //   //   setShipmentsState(result.data[0].data.shipment_num as number);
  //   //   console.log(result.data[0].data.shipment_num as number);
  //   // });

  // }, []);

  // Shipments - START
  const shipmentsQuery: IQuery = {
    tableName: "sa_m24l_shipment",
    select: [
      {
        fullColumnName: "shipment_num",
        aggregate: "COUNT"
      }
    ],
    groupBy: [],
    join: [],
    orderBy: [],
    where: [
        {
          fullColumnName: "integration_status",
          value: "CLOSED",
          operator: "NE",
          cast: CastType.STRING
        }        
    ],
    mainTableOnly: false,
    includeExtraColumns: false,
    includeControlColumns: false,
    modifiedAfter: null,
    touchedBefore: null,
    isDirty: null,
    frontEndOnly: null
  }

  const shipments = {
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      series: [
        {
          name: 'Amount',
          type: 'gauge',
          progress: {
            show: true
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}'
          },
          data: [
            {
              value: shipmentsState,
              name: 'Shipments'
            }
          ]
        }       
      ]
  };
  // Shipments - END

  //Movements In - START
  const movementsInQuery: IQuery = {
    tableName: "sa_m24l_stock_movement_in",
    select: [
      {
        fullColumnName: "doc_num",
        aggregate: "COUNT"
      }
    ],
    groupBy: [],
    join: [],
    orderBy: [],
    where: [
        {
          fullColumnName: "integration_status",
          value: "CLOSED",
          operator: "NE",
          cast: CastType.STRING
        }        
    ],
    mainTableOnly: false,
    includeExtraColumns: false,
    includeControlColumns: false,
    modifiedAfter: null,
    touchedBefore: null,
    isDirty: null,
    frontEndOnly: null
  }

  const movementsIn = {
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      series: [
        {
          name: 'Amount',
          type: 'gauge',
          progress: {
            show: true
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}'
          },
          data: [
            {
              value: movementsInState,
              name: 'Movements-In'
            }
          ]
        }
      ]
  };
  // MovementsIn - END

  // MovementsOut - START
  const movementsOutQuery: IQuery = {
    tableName: "sa_m24l_stock_movement_out",
    select: [
      {
        fullColumnName: "doc_num",
        aggregate: "COUNT"
      }
    ],
    groupBy: [],
    join: [],
    orderBy: [],
    where: [
        {
          fullColumnName: "integration_status",
          value: "CLOSED",
          operator: "NE",
          cast: CastType.STRING
        }        
    ],
    mainTableOnly: false,
    includeExtraColumns: false,
    includeControlColumns: false,
    modifiedAfter: null,
    touchedBefore: null,
    isDirty: null,
    frontEndOnly: null
  }

  const movementsOut = {
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      series: [
        {
          name: 'Amount',
          type: 'gauge',
          progress: {
            show: true
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}'
          },
          data: [
            {
              value: movementsOutState,
              name: 'Movements-Out'
            }
          ]
        }
      ]
  };
  // MovementsOut - END

  // StocckMaster - START
  const stockmasterQuery: IQuery = {
    tableName: "sa_m24l_item",
    select: [
      {
        fullColumnName: "item_code",
        aggregate: "COUNT"
      }
    ],
    groupBy: [],
    join: [],
    orderBy: [],
    where: [
        {
          fullColumnName: "integration_status",
          value: "SENT",
          operator: "NE",
          cast: CastType.STRING
        }        
    ],
    mainTableOnly: false,
    includeExtraColumns: false,
    includeControlColumns: false,
    modifiedAfter: null,
    touchedBefore: null,
    isDirty: null,
    frontEndOnly: null
  }  
  const stockmaster = {
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      series: [
        {
          name: 'Amount',
          type: 'gauge',
          progress: {
            show: true
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}'
          },
          data: [
            {
              value: stockmasterState,
              name: 'Stock Master'
            }
          ]
        }
      ]
  };
  // StockMaster - END

  // Adjustments - START
  // const adjustmentsQuery: IQuery = {
  //   tableName: "sa_m24l_adjustments",
  //   select: [
  //     {
  //       fullColumnName: "doc_num",
  //       aggregate: "COUNT"
  //     }
  //   ],
  //   groupBy: [],
  //   join: [],
  //   orderBy: [],
  //   where: [
  //       {
  //         fullColumnName: "integration_status",
  //         value: "CLOSED",
  //         operator: "NE",
  //         cast: CastType.STRING
  //       }        
  //   ],
  //   mainTableOnly: false,
  //   includeExtraColumns: false,
  //   includeControlColumns: false,
  //   modifiedAfter: null,
  //   touchedBefore: null,
  //   isDirty: null,
  //   frontEndOnly: null
  // }  
  const adjustments = {
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      series: [
        {
          name: 'Amount',
          type: 'gauge',
          progress: {
            show: true
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}'
          },
          data: [
            {
              value: adjustmentsState,
              name: 'Adjustments'
            }
          ]
        }
      ]
  };
  // Adjustments - END

  // Levels - START
  // const levelsQuery: IQuery = {
  //   tableName: "sa_m24l_stock_levels",
  //   select: [
  //     {
  //       fullColumnName: "doc_num",
  //       aggregate: "COUNT"
  //     }
  //   ],
  //   groupBy: [],
  //   join: [],
  //   orderBy: [],
  //   where: [
  //       {
  //         fullColumnName: "integration_status",
  //         value: "CLOSED",
  //         operator: "NE",
  //         cast: CastType.STRING
  //       }        
  //   ],
  //   mainTableOnly: false,
  //   includeExtraColumns: false,
  //   includeControlColumns: false,
  //   modifiedAfter: null,
  //   touchedBefore: null,
  //   isDirty: null,
  //   frontEndOnly: null
  // }

  const levels = {
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      series: [
        {
          name: 'Amount',
          type: 'gauge',
          progress: {
            show: true
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}'
          },
          data: [
            {
              value: levelsState,
              name: 'Stock Level'
            }
          ]
        }
      ]
  };
  // Levels - END

  useEffect(() => {

    const ship = () => {
      const res = shipmentsState + 2;
      console.log(res);
      setShipmentsState(shipmentsState + 2);
    };

    const intervalId = setInterval(ship, 15000);

    // Cleanup function to stop the interval when component unmounts
    return () => clearInterval(intervalId);

  }, []);

  return(
        <React.Fragment>
            <Container fluid className="p-0" >
            <div className="d-flex justify-content-center w-100 mt-0">
                {/* Query Chart Here */}
                <div id="main" className="d-flex justify-content-center w-30" style={{width: "30%", height: "250px"}}>
                  <QueryChart option={shipments} />
                </div>
                <div id="main" className="d-flex justify-content-center w-30" style={{width: "30%", height: "250px"}}>
                  <QueryChart option={movementsIn} />
                </div>
                <div id="main" className="d-flex justify-content-center w-30" style={{width: "30%", height: "250px"}}>
                  <QueryChart option={movementsOut} />                  
                </div>
                {/* Query List Here */}
            </div>
            <div className="d-flex justify-content-center w-100" >
                {/* Query Chart Here */}
                <div id="main" className="d-flex justify-content-center w-30" style={{width: "30%", height: "400px"}}>
                  <QueryChart option={stockmaster} />
                </div>                
                <div id="main" className="d-flex justify-content-center w-30" style={{width: "30%", height: "400px"}}>
                  <QueryChart option={adjustments} />
                </div>
                <div id="main" className="d-flex justify-content-center w-30" style={{width: "30%", height: "400px"}}>
                  <QueryChart option={levels} />                  
                </div>
                {/* Query List Here */}
            </div>            

            </Container>
      </React.Fragment>
  );
}